<template>
  <div>
    <ca-heading text="Estabelecimento" />

    <ca-page>
      <ca-loader v-if="showLoading"></ca-loader>

      <ca-form
        v-else
        :on-submit="onSubmit"
        :on-submit-success="onSubmitSuccess"
        :on-submit-error="onSubmitError"
        :error-message="errorMessage">
        <ca-row>
          <ca-col size="6">
            <ca-field label="Tipo Inscrição">
              <ca-select v-model="establishment.registrationType.name" disabled>
                <ca-option
                  v-for="insciptionType in misc.companyInscriptionType"
                  :key="insciptionType.name"
                  :value="insciptionType.name">
                  {{ insciptionType.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Inscrição">
              <ca-input
                v-model="establishment.registration"
                mask-pattern="99.999.999/9999-99"
                required></ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field
              label="CNAE Preponderante"
              icon-tooltip="Digite o número da principal Classificação Nacional de Atividades
              Econômicas do empregador. O CNAE pode ser consultado no site do IBGE.">
              <ca-input
                v-model="establishment.preponderantCnae"
                mask-pattern="9999-9/99"
                required></ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field
              label="Alíquota RAT"
              icon-tooltip="Alíquota de Riscos Ambientais do Trabalho: 1% se a atividade é de
                risco mínimo; 2% se de risco médio e de 3% se de risco grave.
                Digite 0 em case de MEI.">
              <ca-input
                v-model="establishment.ratAliquot"
                v-mask="'#'"
                type="number"
                min="0"
                max="3"
                required>
              </ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="FAP">
              <percent-input
                v-model="establishment.fap"
                :integer-places="1"
                :decimal-places="4"
                required></percent-input>
            </ca-field>
          </ca-col>

          <ca-col v-if="isCaepfInscription" size="6">
            <ca-field label="Tipo de CAEPF">
              <ca-select v-model="establishment.naturalPersonCaeType.name">
                <ca-option
                  v-for="caepfType in misc.caepfTypes"
                  :key="caepfType.name"
                  :value="caepfType.name">
                  {{ caepfType.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>

          <ca-col v-if="isCaepfInscription" size="6">
            <ca-field label="CEI para SEFIP">
              <ca-input
                v-model="establishment.ceiSefip"
                maxlength="18"></ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Opção de Registro de Ponto">
              <ca-select v-model="establishment.electronicPointType.name">
                <ca-option
                  v-for="eletronicPointType in misc.eletronicPointTypes"
                  :key="eletronicPointType.name"
                  :value="eletronicPointType.name">
                  {{ eletronicPointType.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Contratação de Aprendiz">
              <ca-select v-model="establishment.apprenticeContracting.name">
                <ca-option
                  v-for="option in misc.apprenticeHiringIndication"
                  :key="option.name"
                  :value="option.name">
                  {{ option.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>

          <ca-col v-if="establishment.apprenticeContracting.name === 'N'" size="6">
            <ca-field
              label="Realiza a contratação de aprendiz por intermédio
              de entidade educativa sem fins lucrativos">
              <ca-checkbox
                v-model="establishment.contEntEdu"
                label="Sim">
              </ca-checkbox>
            </ca-field>
          </ca-col>

          <ca-col v-if="establishment.registrationType === 'O'" size="6">
            <ca-field label="Substituição da Contribuição Patronal de Obra">
              <ca-input v-model="establishment.indContPatObra"></ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="CEP">
              <ca-cep-data-search
                v-model="establishment.zipCode"
                required
                :on-search="onCepSearch"
                :on-search-success="onCepSearchSuccess">
              </ca-cep-data-search>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Logradouro">
              <ca-input
                v-model="establishment.address"
                maxlength="80"></ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Número">
              <ca-input
                v-model="establishment.number"
                maxlength="8"></ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Bairro">
              <ca-input
                v-model="establishment.neighborhood"
                maxlength="30"></ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Complemento">
              <ca-input
                v-model="establishment.complement"
                maxlength="30"></ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Cidade">
              <ca-input
                v-model="establishment.city"
                maxlength="30"></ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Estado">
              <ca-search-select
                v-model="establishment.state.name"
                :selected-option="selectedUf"
                placeholder="Selecione"
                required>
                <ca-option
                  v-for="state in misc.uf"
                  :key="state.name"
                  :value="state.name"
                  placeholder="Selecione">
                  {{ state.description }}
                </ca-option>
              </ca-search-select>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Telefone">
              <ca-input
                v-model="establishment.phone"
                v-mask="['(##) ####-####', '(##) #####-####']">
              </ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field
              label="Denominação"
              icon-tooltip="Se preenchido será esta denominação no cabeçalho do holerite,
              se deixar em branco será impresso o nome do empregador.">
              <ca-input
                v-model="establishment.denomination"
                maxlength="80">
              </ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="3">
            <ca-field label="Situação no eSocial">
              <ca-select
                v-model="establishment.statusEsocial.name"
                :on-change="onChangeStatusESocial">
                <ca-option
                  v-for="status in misc.esocialStatus.default"
                  :key="status.name"
                  :value="status.name">
                  {{ status.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>
          <ca-col v-if="requireESocialChangeDate" size="3">
            <ca-field label="Data de alteração">
              <ca-date-input
                v-model="establishment.esocialChangeDate"
                :required="requireESocialChangeDate">
              </ca-date-input>
            </ca-field>
          </ca-col>
        </ca-row>

        <ca-footer>
          <ca-row vertical-offset="2">
            <ca-col size="2">
              <ca-button full-width @click="goBack">
                Voltar
              </ca-button>
            </ca-col>
            <ca-col offset="8" size="2">
              <ca-submit-button>
                Salvar
              </ca-submit-button>
            </ca-col>
          </ca-row>
        </ca-footer>
      </ca-form>
    </ca-page>
  </div>
</template>

<script>
import { initFormObject, getBoxInformationErrorMessage } from 'packages/common/utils';
import {
  getEstablishment, editEstablishment, getCepInformation, getCorrectESocialChangeDate,
} from './establishmentService';

export default {
  name: 'EstablishmentForm',
  data() {
    return {
      establishment: initFormObject([
        'registrationType',
        'naturalPersonCaeType',
        'electronicPointType',
        'apprenticeContracting',
        'state',
        'statusEsocial']),
      errorMessage: null,
      selectedUf: null,
    };
  },
  computed: {
    showLoading() {
      return this.establishment.loading;
    },
    misc() {
      return this.$store.state.misc;
    },
    isLegalInscription() {
      return this.establishment.registrationType.name === 'J';
    },
    isCaepfInscription() {
      return this.establishment.registrationType.name === 'C';
    },
    requireESocialChangeDate() {
      return this.establishment.statusEsocial.name === 'A';
    },
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.$store.dispatch('misc/getCompanyInscriptionType', 'ESTABS');
      this.$store.dispatch('misc/getUf');
      this.$store.dispatch('misc/getEsocialStatus');
      this.$store.dispatch('misc/getCaepfTypes');
      this.$store.dispatch('misc/getEletronicPointTypes');
      this.$store.dispatch('misc/getApprenticeHiringIndication');
      this.setEstablishment();
    },
    async setEstablishment() {
      this.establishment = await getEstablishment();

      this.onChangeStatusESocial();
    },
    onCepSearch() {
      return getCepInformation(this.establishment.zipCode);
    },
    onCepSearchSuccess(response) {
      const {
        neighborhood, city, streetAddress, state,
      } = response;

      this.$set(this.establishment, 'address', streetAddress);
      this.$set(this.establishment, 'neighborhood', neighborhood);
      this.$set(this.establishment, 'city', city);
      this.selectedUf = { label: state, value: state };
    },
    goBack() {
      this.$router.push({ name: 'EstablishmentView' });
    },
    onSubmit() {
      return editEstablishment(this.establishment);
    },
    onSubmitSuccess() {
      this.goBack();
      this.$toaster.success('Dados salvos com sucesso');
    },
    onSubmitError(error) {
      this.errorMessage = getBoxInformationErrorMessage(error);
    },
    onChangeStatusESocial() {
      this.$set(this.establishment, 'esocialChangeDate', getCorrectESocialChangeDate(this.establishment.esocialChangeDate, this.requireESocialChangeDate));
    },
  },
};
</script>
